/**
 * 模組頁面代碼:
 * 模組說明: 聯絡我們
 * @module Contact
 */

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../../components/BaseComponent';

// ----- import from local components -----
import Header from './Header';
import Footer from './Footer';
import { MessageModal, MessageModalModeEnums } from '../../../components/MessageModal';

export default class ContactContainer extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
        };
        this.messageModalRef = React.createRef();
        this.messageModal = null;
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.ERROR, title = '', message = '請先登入') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    componentDidMount() {
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }

    componentWillUnmount() {
        this.toggleMessageModal(false);
    }

    toggleLoginMessageModal = (isShow) => {
        this.toggleMessageModal(isShow, MessageModalModeEnums.INFO, '登入提示', '請先登入');
    }

    render() {
        return (
            <React.Fragment>
                <Header toggleLoginMessageModal={this.toggleLoginMessageModal} />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {/* container*/}
                        <section className="static-content">
                            <div className="static-content__head">
                                <h2>聯絡我們</h2>
                            </div>
                            <div className="static-content__body">
                                <div className="d-flex flex-column gap-3">
                                    <div>
                                        <span className="fa-stack fa-lg">
                                            <i className="fa fa-circle fa-stack-2x"></i> <i className="fa fa-phone fa-stack-1x fa-inverse"></i>
                                        </span>
                                        02-2733-5353 (代表號)
                                    </div>
                                    <div>
                                        <span className="fa-stack fa-lg">
                                            <i className="fa fa-circle fa-stack-2x"></i> <i className="fa fa-fax fa-stack-1x fa-inverse"></i>
                                        </span>
                                        02-2732-3107
                                    </div>
                                    <div>
                                        <span className="fa-stack fa-lg">
                                            <i className="fa fa-circle fa-stack-2x"></i> <i className="fa fa-map-marker fa-stack-1x fa-inverse"></i>
                                        </span>
                                        台北市復興南路2段363號中菱大樓
                                    </div>
                                </div>
                            </div>
                            {/* container*/}
                        </section>
                    </div>
                </div>
                <Footer />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}
